(() => {

  var CombinedProductApp = (() => {
    let productData = null;
    let selectedVariants = {
      child1: null,
      child2: null
    };
    let selectedOptions = {
      child1: {},
      child2: {}
    };

    var initialize = () => {
      document.querySelectorAll('[js-custom-featured-product-submit]').forEach(element => {
        element.addEventListener('click', (event) => {
          handleAppAddToCart(event);
        });
      });
      document.querySelectorAll('.featured-combined-product--container').forEach(container => {
        let interval_time = 0;
        const interval_id = setInterval(() => {
          if (container.querySelectorAll('.kaching-bundles__bar.kaching-bundles__bar--selected .kaching-bundles__bar-variant').length > 0) {
            showPersonalization(container);
            interval_time = 30000;
          }
          interval_time+=100;
          if (interval_time >= 30000) {
            clearInterval(interval_id);
          }
        }, 100);
      });
      document.querySelectorAll('.featured-combined-product--container').forEach(element => {
        element.addEventListener('click', function(e) {
          if (e.target.closest('.kaching-bundles__bars')) {
            setTimeout(() => {
              showPersonalization(element);
            }, 300);
          }
        });
      });
      if (window.combinedProductData) {
        productData = window.combinedProductData;
        setupEventListeners();
        initializeDefaultSelections();
      }
    };

    var showPersonalization = (container) => {
      if (!container) return;
      const variantCount = container.querySelectorAll('.kaching-bundles__bar.kaching-bundles__bar--selected .kaching-bundles__bar-variant').length;
      document.querySelectorAll('.product_block--personalization').forEach((element, index) => {
        if (index < variantCount) {
          element.classList.remove('d-none');
        } else {
          element.classList.add('d-none');
        }
      });

      document.querySelectorAll('.shopify-section--bd-featured-product .product_block--personalization').forEach((element, index) => {
        const image = element.querySelector('.spb-label-tooltip .image-wrapper img');
        if (image) {
          try {
            const imageElement = document.querySelectorAll('.kaching-bundles__bar.kaching-bundles__bar--selected .kaching-bundles__bar-variant-custom-selects[data-name="Color"]')[index].querySelector('.image-wrapper img');
            image.src = imageElement.src;
          } catch (error) {}
        } else {
          try {
            const imageElement = document.querySelectorAll('.kaching-bundles__bar.kaching-bundles__bar--selected .kaching-bundles__bar-variant-custom-selects[data-name="Color"]')[index].querySelector('.image-wrapper');
            element.querySelector('.spb-label-tooltip').innerHTML = imageElement.outerHTML + element.querySelector('.spb-label-tooltip').innerHTML;
          } catch (error) {}
        }
      });
    }

    var setupEventListeners = () => {
      document.querySelectorAll('[js-combined-product-variant-picker] .size-value').forEach(element => {
        element.addEventListener('click', handleSizeSelection);
      });

      document.querySelectorAll('[js-combined-product-variant-picker] .color-value').forEach(element => {
        element.addEventListener('click', () => {
          handleColorSelection(element);
        });
      });

      const atcButton = document.querySelector('[js-combined-product-submit]');
      if (atcButton) {
        atcButton.addEventListener('click', handleAddToCart);
      }
    };

    var initializeDefaultSelections = () => {
      document.querySelectorAll('[js-combined-product-variant-picker] .size-selector').forEach((selector, index) => {
        const firstSize = selector.querySelector('.size-value.selected');
        if (firstSize) {
          const productKey = index === 0 ? 'child1' : 'child2';
          const optionPosition = parseInt(firstSize.dataset.optionPosition);
          const optionValue = firstSize.dataset.optionValue;
          selectedOptions[productKey][optionPosition] = optionValue;
        }
      });

      const firstColor = document.querySelector('[js-combined-product-variant-picker] .color-value.selected');
      if (firstColor) {
        const optionPosition1 = parseInt(firstColor.dataset["optionPositionForChild-1"]);
        const optionPosition2 = parseInt(firstColor.dataset["optionPositionForChild-2"]);
        const optionValue = firstColor.dataset.optionValue;
        selectedOptions.child1[optionPosition1] = optionValue;
        selectedOptions.child2[optionPosition2] = optionValue;
      }

      updateVariantsAndAvailability();
    };

    var handleSizeSelection = (event) => {
      const clickedElement = event.target;
      const sizeSelector = clickedElement.closest('[js-combined-product-variant-picker] .size-selector');
      const selectorIndex = Array.from(document.querySelectorAll('[js-combined-product-variant-picker] .size-selector')).indexOf(sizeSelector);
      const productKey = selectorIndex === 0 ? 'child1' : 'child2';

      sizeSelector.querySelectorAll('.size-value').forEach(el => {
        el.classList.remove('selected');
      });

      clickedElement.classList.add('selected');

      const optionPosition = parseInt(clickedElement.dataset.optionPosition);
      const optionValue = clickedElement.dataset.optionValue;
      selectedOptions[productKey][optionPosition] = optionValue;

      updateVariantsAndAvailability();
    };

    var handleColorSelection = (element) => {
      const clickedElement = element;

      document.querySelectorAll('[js-combined-product-variant-picker] .color-value').forEach(el => {
        el.classList.remove('selected');
      });

      clickedElement.classList.add('selected');

      const optionPosition1 = parseInt(clickedElement.dataset["optionPositionForChild-1"]);
      const optionPosition2 = parseInt(clickedElement.dataset["optionPositionForChild-2"]);
      const optionValue = clickedElement.dataset.optionValue;
      selectedOptions.child1[optionPosition1] = optionValue;
      selectedOptions.child2[optionPosition2] = optionValue;

      updateVariantsAndAvailability();
    };

    var findVariantByOptions = (product, options) => {
      if (!product || !product.variants) return null;

      return product.variants.find(variant => {
        return variant.options.every((option, index) => {
          const selectedOption = options[index + 1]; // Options are 1-indexed
          return selectedOption === option;
        });
      });
    };

    var updateVariantsAndAvailability = () => {
      selectedVariants.child1 = findVariantByOptions(productData.childProduct1, selectedOptions.child1);
      selectedVariants.child2 = findVariantByOptions(productData.childProduct2, selectedOptions.child2);

      updateSizeAvailability();
      updateColorAvailability();

      console.log('Selected variants:', selectedVariants);
    };

    var updateSizeAvailability = () => {
      document.querySelectorAll('[js-combined-product-variant-picker] .size-selector').forEach((selector, index) => {
        const productKey = index === 0 ? 'child1' : 'child2';
        const product = productKey === 'child1' ? productData.childProduct1 : productData.childProduct2;

        selector.querySelectorAll('.size-value').forEach(sizeElement => {
          const optionPosition = parseInt(sizeElement.dataset.optionPosition);
          const optionValue = sizeElement.dataset.optionValue;

          // Create test options with this size
          const testOptions = { ...selectedOptions[productKey] };
          testOptions[optionPosition] = optionValue;

          // Check if variant exists and is available
          const testVariant = findVariantByOptions(product, testOptions);
          console.log('here is testVariant', testVariant, testOptions);
          const isAvailable = testVariant && testVariant.available;

          // Update disabled state
          if (isAvailable) {
            sizeElement.classList.remove('disabled');
          } else {
            sizeElement.classList.add('disabled');
          }
        });
      });
    };

    var updateColorAvailability = () => {
      document.querySelectorAll('[js-combined-product-variant-picker] .color-value').forEach(colorElement => {
        const optionPosition1 = parseInt(colorElement.dataset["optionPositionForChild-1"]);
        const optionPosition2 = parseInt(colorElement.dataset["optionPositionForChild-2"]);
        const optionValue = colorElement.dataset.optionValue;

        const testOptions1 = { ...selectedOptions.child1 };
        const testOptions2 = { ...selectedOptions.child2 };
        testOptions1[optionPosition1] = optionValue;
        testOptions2[optionPosition2] = optionValue;

        const testVariant1 = findVariantByOptions(productData.childProduct1, testOptions1);
        const testVariant2 = findVariantByOptions(productData.childProduct2, testOptions2);

        const isAvailable = (testVariant1 && testVariant1.available) && (testVariant2 && testVariant2.available);

        if (isAvailable) {
          colorElement.classList.remove('disabled');
        } else {
          colorElement.classList.add('disabled');
        }
      });
    };
    
    var handleAppAddToCart = async (event) => {
      event.preventDefault();
      
      const button = event.target;
      
      button.setAttribute('aria-busy', 'true');

      try {
        let personalizationDataList = [];
        document.querySelectorAll('.product_block--personalization input').forEach(input => {
          const personalizationData = {};
          if (input.value.trim()) {
            personalizationData[input.name] = input.value.trim();
          }
          personalizationDataList.push(personalizationData);
        });

        // Prepare sections to bundle (following theme pattern)
        let sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { 
          bubbles: true, 
          detail: { sections: sectionsToBundle } 
        }));
    
        let variantIdList = [];
        if (!document.querySelector('kaching-bundles-block[product]')) return;
        const productJson = JSON.parse(document.querySelector('kaching-bundles-block[product]').getAttribute('product'));
        document.querySelectorAll('.kaching-bundles__bar--selected .kaching-bundles__bar-variant-selects').forEach(element => {
          productJson.variants.forEach(variant => {
            let flag = true;
            element.querySelectorAll('select[data-name]').forEach((select, index) => {
              if (variant.options[index] !== select.value) {
                flag = false;
              }
            });
            if (flag) {
              variantIdList.push(variant.id);
            }
          });
        });
        let items = [];
        variantIdList.forEach((variantId, index) => {
          items.push({
            id: variantId,
            quantity: 1,
            properties: {
              ... personalizationDataList[index]
            }
          });
        });

        // Add to cart via Shopify Cart API
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items })
        });
    
        const responseJson = await response.json();
    
        if (response.ok) {
          if (window.themeVariables.settings.cartType === 'page') {
            return window.location.href = `${Shopify.routes.root}cart`;
          }
    
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

          let sections = null;
          if (sectionsToBundle.length > 0) {
            const sectionsResponse = await fetch(`${Shopify.routes.root}cart?sections=${sectionsToBundle.join(',')}`);
            sections = await sectionsResponse.json();
          }

          cartContent['sections'] = sections;
          
          document.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson,
              cart: cartContent
            }
          }));

          console.log('here is cartContent', cartContent);
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent
            }
          }));
    
        } else {
          throw new Error(responseJson['description'] || 'Failed to add to cart');
        }
    
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert(error.message || 'There was an error adding items to cart. Please try again.');
        
      } finally {
        // Remove loading state
        button.removeAttribute('aria-busy');
      }
    }

    var handleAddToCart = async (event) => {
      event.preventDefault();
      
      const button = event.target;
      
      // Check if variants are selected and available
      if (!selectedVariants.child1 || !selectedVariants.child2) {
        alert('Please select all options before adding to cart.');
        return;
      }
    
      if (!selectedVariants.child1.available || !selectedVariants.child2.available) {
        alert('Selected variants are not available.');
        return;
      }
    
      // Set button loading state using theme's custom button pattern
      button.setAttribute('aria-busy', 'true');
    
      try {
        // Collect personalization data
        const personalizationData = {};
        document.querySelectorAll('.product_block--personalization input').forEach(input => {
          if (input.value.trim()) {
            personalizationData[input.name] = input.value.trim();
          }
        });
    
        // Prepare sections to bundle (following theme pattern)
        let sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { 
          bubbles: true, 
          detail: { sections: sectionsToBundle } 
        }));
    
        const bundlePairId = `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const parentProduct = window.combinedProductData.parentProduct;

        const items = [
          {
            id: selectedVariants.child1.id,
            quantity: 1,
            properties: {
              ... personalizationData,
              '_bundle_child_id': bundlePairId,
              '_bundle_title': parentProduct.title,
              '_bundle_parent_variant_id': `gid://shopify/ProductVariant/${parentProduct.variants[0]?.id}`,
              '_bundle_price': (parentProduct.price / 100).toString(),
              '_bundle_image': parentProduct.featured_image || parentProduct.images[0],
              'Personalization': JSON.stringify(personalizationData)
            }
          },
          {
            id: selectedVariants.child2.id,
            quantity: 1,
            properties: {
              ... personalizationData,
              '_bundle_child_id': bundlePairId,
              '_bundle_title': parentProduct.title,
              '_bundle_parent_variant_id': `gid://shopify/ProductVariant/${parentProduct.variants[0]?.id}`,
              '_bundle_price': (parentProduct.price / 100).toString(),
              '_bundle_image': parentProduct.featured_image || parentProduct.images[0],
              'Personalization': JSON.stringify(personalizationData)
            }
          }
        ];
    
        // Add to cart via Shopify Cart API
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items })
        });
    
        const responseJson = await response.json();
    
        if (response.ok) {
          if (window.themeVariables.settings.cartType === 'page') {
            return window.location.href = `${Shopify.routes.root}cart`;
          }
    
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

          let sections = null;
          if (sectionsToBundle.length > 0) {
            const sectionsResponse = await fetch(`${Shopify.routes.root}cart?sections=${sectionsToBundle.join(',')}`);
            sections = await sectionsResponse.json();
          }

          cartContent['sections'] = sections;
          
          document.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson,
              cart: cartContent
            }
          }));
    
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent
            }
          }));
    
        } else {
          throw new Error(responseJson['description'] || 'Failed to add to cart');
        }
    
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert(error.message || 'There was an error adding items to cart. Please try again.');
        
      } finally {
        // Remove loading state
        button.removeAttribute('aria-busy');
      }
    };

    return {
      init: initialize,
      getSelectedVariants: () => selectedVariants,
      getSelectedOptions: () => selectedOptions
    };
  })();

  var TimerApp = (() => {
    var timers = [];
  
    var showFixedTimer = (element) => {
      const container = element.closest('.product_block--timer_countdown');
      const fixedTimer = document.querySelector('.timer.fixed-position:has([js-combined-product-timer])');
      const header = document.querySelector('store-header');
      if (!container || !fixedTimer || !header) return;
      container.style.setProperty('--header-height', header.clientHeight + 'px');
      const top = element.getBoundingClientRect().top * -1;
      if (window.innerWidth < 1000 && container.classList.contains('desktop-hide')) {
        if (top > element.clientHeight) {
          fixedTimer.classList.add('show');
        } else {
          fixedTimer.classList.remove('show');
        }
      }
      if (window.innerWidth >= 1000 && container.classList.contains('mobile-hide')) {
        if (top > element.clientHeight) {
          fixedTimer.classList.add('show');
        } else {
          fixedTimer.classList.remove('show');
        }
      }
    }
    var initialize = () => {
      document.querySelectorAll('[js-combined-product-timer]').forEach(element => {
        let initialSeconds = 0;
        if (element.hasAttribute('js-featured-product-timer')) {
          const now = new Date();
          const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
          initialSeconds = parseInt(24 * 3600 - currentSeconds);
          element.setAttribute('data-remaining-seconds', initialSeconds);
        } else {
          initialSeconds = parseInt(element.dataset.remainingSeconds);
        }
        const timerId = generateTimerId(element);
        
        if (initialSeconds > 0) {
          startTimer(element, initialSeconds, timerId);
        }
      });

      window.addEventListener('scroll', () => {
        document.querySelectorAll('[js-combined-product-timer]').forEach(element => {
          showFixedTimer(element);
        });
      });
    };
  
    var generateTimerId = (element) => {
      // Create unique timer ID based on section and timer settings
      const section = element.closest('.shopify-section');
      const sectionId = section ? section.id : 'default';
      return `timer_${sectionId}`;
    };
  
    var getStoredTimer = (timerId) => {
      const stored = localStorage.getItem(timerId);
      if (stored) {
        const data = JSON.parse(stored);
        
        if (data.isEnded) {
          localStorage.removeItem(timerId);
          return null;
        }
        
        const now = Date.now();
        const elapsed = Math.floor((now - data.startTime) / 1000);
        const remaining = data.initialSeconds - elapsed;
        return remaining > 0 ? remaining : 0;
      }
      return null;
    };
  
    var storeTimer = (timerId, initialSeconds) => {
      const timerData = {
        startTime: Date.now(),
        initialSeconds: initialSeconds,
        isEnded: false
      };
      localStorage.setItem(timerId, JSON.stringify(timerData));
    };
  
    var markTimerAsEnded = (timerId) => {
      const stored = localStorage.getItem(timerId);
      if (stored) {
        const data = JSON.parse(stored);
        data.isEnded = true;
        localStorage.setItem(timerId, JSON.stringify(data));
      }
    };
  
    var startTimer = (element, initialSeconds, timerId) => {
      const hourSpan = element.querySelector('[data-hour-label]');
      const minuteSpan = element.querySelector('[data-minute-label]');
      const secondSpan = element.querySelector('[data-second-label]');
      
      const hourLabel = hourSpan.dataset.hourLabel || 'h';
      const minuteLabel = minuteSpan.dataset.minuteLabel || 'min';
      const secondLabel = secondSpan.dataset.secondLabel || 'sec.';
  
      let remainingTime = getStoredTimer(timerId);
      
      if (remainingTime === null) {
        remainingTime = initialSeconds;
        storeTimer(timerId, initialSeconds);
      } else if (remainingTime <= 0) {
        onTimerEnd(element, timerId);
        return;
      }
  
      const updateDisplay = () => {
        const hours = Math.floor(remainingTime / 3600);
        const minutes = Math.floor((remainingTime % 3600) / 60);
        const seconds = remainingTime % 60;
  
        hourSpan.textContent = `${hours}${hourLabel}`;
        minuteSpan.textContent = `${minutes}${minuteLabel}`;
        secondSpan.textContent = `${seconds}${secondLabel}`;
  
        if (remainingTime <= 0) {
          clearInterval(timer);
          onTimerEnd(element, timerId);
        }
      };
  
      const timer = setInterval(() => {
        remainingTime--;
        updateDisplay();
      }, 1000);
  
      timers.push(timer);
      
      updateDisplay();
    };
  
    var onTimerEnd = (element, timerId) => {
      markTimerAsEnded(timerId);
      element.classList.add('timer-ended');
    };
  
    var resetTimer = (timerId) => {
      localStorage.removeItem(timerId);
    };
  
    var resetAllTimers = () => {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('timer_')) {
          localStorage.removeItem(key);
        }
      });
    };
  
    var cleanup = () => {
      timers.forEach(timer => clearInterval(timer));
      timers = [];
    };
  
    return {
      init: initialize,
      cleanup: cleanup,
      resetTimer: resetTimer,
      resetAllTimers: resetAllTimers
    };
  })();

  var TooltipIconApp = (() => {
    var openTooltip = (element) => {
      if (!element) return;
      element.classList.add('active');
    }
    var closeTooltip = (element) => {
      if (!element) return;
      element.classList.remove('active');
    }
    var initialize = () => {
      document.querySelectorAll('[js-tooltip-icon]').forEach(element => {
        element.addEventListener('mouseover', () => {
          openTooltip(element);
        });
        element.addEventListener('click', () => {
          openTooltip(element);
        });
        element.addEventListener('mouseleave', () => {
          closeTooltip(element);
        });
        element.addEventListener('focusout', () => {
          closeTooltip(element);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var ShippingProtectApp = (() => {
    let shippingProtectLineId = null;
    var addShippingProtect = async (variant_id, element) => {
      if (!element) return;
      element.classList.add('loading');
      element.classList.add('active');
      const formData = new URLSearchParams();
      formData.append('id', variant_id);
      formData.append('quantity', 1);
      formData.append('properties[_is_shipping_protect]', true);
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
  
        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    };
    var removeShippingProduct = async (element) => {
      if (!shippingProtectLineId) return;
      if (!element) return;
      element.classList.add('loading');
      element.classList.remove('active');
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: shippingProtectLineId,
          quantity: 0
        })
      })).json();
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
    var checkAddedShippingProduct = async (variant_id) => {
      let flag = false;
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent.items.forEach(item => {
        if (String(item.id) === String(variant_id)) {
          flag = true;
          shippingProtectLineId = item.key;
        }
      });
      return flag;
    }
    var trigger = async (element) => {
      if (!element) return;
      if (element.classList.contains('loading')) return;
      const flag = await checkAddedShippingProduct(element.getAttribute('data-variant-id'));
      if (!flag) {
        addShippingProtect(element.getAttribute('data-variant-id'), element);
      } else {
        removeShippingProduct(element);
      }
    }
    var initialize = () => {
      document.addEventListener('click', (event) => {
        let element = null;
        if (event.target.hasAttribute('js-shipping-protect-trigger')) {
          element = event.target;
        }
        if (event.target.closest('[js-shipping-protect-trigger]')) {
          element = event.target.closest('[js-shipping-protect-trigger]');
        }
        if (element) {
          trigger(element);
        }
      });
    }
    return {
      init: initialize
    }
  })();

  var CartTimerApp = (() => {
    const TIMER_KEY = "reservation_timer_end";
    const RESERVATION_DURATION_MINUTES = 10;
  
    var runCountdown = () => {
      setInterval(() => {
        let endTime = localStorage.getItem(TIMER_KEY);

        if (!endTime) {
          return;
        }

        endTime = parseInt(endTime, 10);

        const timerElement = document.querySelector("[js-cart-drawer-timer]");
        if (!timerElement) return;
        const now = Date.now();
        const remaining = endTime - now;
  
        if (remaining <= 0) {
          timerElement.style.display = 'none';
          localStorage.removeItem(TIMER_KEY);
          return;
        }

        timerElement.style.display = 'flex';
  
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
  
        if (timerElement.querySelector('[data-template]')) {
          timerElement.querySelector('[data-template]').innerText = String(timerElement.querySelector('[data-template]').getAttribute('data-template')).replace('((value))', `${pad(minutes)}:${pad(seconds)}`);
        }
      }, 3);
    }
  
    var pad = (n) => {
      return n < 10 ? '0' + n : n;
    }

    var initialize = () => {
      let endTime = localStorage.getItem(TIMER_KEY);

      if (!endTime) {
        const now = new Date();
        now.setMinutes(now.getMinutes() + RESERVATION_DURATION_MINUTES);
        endTime = now.getTime();
        localStorage.setItem(TIMER_KEY, endTime);
      }

      runCountdown();
    }
    return {
      init: initialize
    }
  })();

  var CartDrawerUpsellProductApp = (() => {
    var addUpsellProduct = async (container) => {
      if (!container) return;
      const selectElement = container.querySelector('[js-cart-drawer-upsell-variant-id]');
      if (!selectElement) return;
      container.classList.add('loading');
      const formData = new URLSearchParams();
      formData.append('id', selectElement.value);
      formData.append('quantity', 1);
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
  
        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent
            }
          }));
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    }
    var updateVariantImage = (container, variantId) => {
      if (!container) return;
      container.querySelectorAll('[js-upsell-image-wrapper] [data-variant-id]').forEach(element => {
        element.classList.remove('active');
        if (element.getAttribute('data-variant-id') === variantId) {
          element.classList.add('active');
        }
      });
    }
    var initialize = () => {
      document.addEventListener('click', (event) => {
        let element = null;
        if (event.target.hasAttribute('js-cart-drawer-upsell-variant-id')) {
          event.target.addEventListener('change', () => {
            updateVariantImage(event.target.closest('[js-container]'), event.target.value);
          });
        }
        if (event.target.hasAttribute('js-cart-drawer-upsell-atc')) {
          element = event.target;
        }
        if (event.target.closest('[js-cart-drawer-upsell-atc]')) {
          element = event.target.closest('[js-cart-drawer-upsell-atc]');
        }
        if (!element || !element.closest('[js-container]') || element.closest('[js-container]').classList.contains('loading')) {
          return;
        }
        addUpsellProduct(element.closest('[js-container]'));
      });
    }
    return {
      init: initialize
    }
  })();

  var InfoForLineApp = (() => {
    var openElement = (quickAnim = false) => {
      let animDelayTime = 2000;
      if (quickAnim) {
        animDelayTime = 0;
      }
      setTimeout(() => {
        const infoElement = document.querySelector('[js-info-for-line]');
        const animElement = document.querySelector('[js-line-anim-element]');
        if (!infoElement || parseInt(infoElement.getAttribute('js-info-for-line')) <= 0 || !animElement) return;
        let triggerDelayTime = parseInt(infoElement.getAttribute('js-info-for-line'));
        if (quickAnim) {
          triggerDelayTime = 0;
        }
        setTimeout(() => {
          if (quickAnim) {
            infoElement.style.transition = '0s';
          }
          infoElement.style.maxHeight = infoElement.scrollHeight + 'px';
          infoElement.classList.add('active');
          if (quickAnim) {
            setTimeout(() => {
              infoElement.style.transition = '1s';
            }, 1000);
          }
        }, triggerDelayTime);
        setTimeout(() => {
          animElement.style.opacity = '0';
        }, parseInt(infoElement.getAttribute('js-info-for-line')));
      }, animDelayTime);
    }
    var closeElement = () => {
      const infoElement = document.querySelector('[js-info-for-line]');
      const animElement = document.querySelector('[js-line-anim-element]');
      if (!infoElement || parseInt(infoElement.getAttribute('js-info-for-line')) <= 0 || !animElement) return;
      infoElement.style.maxHeight = 0 + 'px';
      infoElement.classList.remove('active');
      animElement.style.opacity = '1';
    }
    var initialize = () => {
      document.addEventListener("cart:change", () => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.hasAttribute('open')) {
          openElement();
        } else {
          closeElement();
        }
      });
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open' && mutation.target.classList.contains('cart-drawer')) {
            const cartDrawer = mutation.target;
            if (cartDrawer.hasAttribute('open')) {
              openElement(true);
            } else {
              closeElement();
            }
          }
        });
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['open'],
        subtree: true,
      });
    }
    return {
      init: initialize
    }
  })();

  var PDPUpsellModalApp = (() => {
    let pdpUpsellModal = null;
    let variantAddEventTrigger = null;
    let variantAddEvent = null;
    let cartChangeEventTrigger = null;
    let cartChangeEvent = null;

    var arraysEqual = (arr1, arr2) => {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    }

    var triggerWaitingEvents = () => {
      if (variantAddEventTrigger && variantAddEvent) {
        variantAddEventTrigger.dispatchEvent(variantAddEvent);
      }
      if (cartChangeEventTrigger && cartChangeEvent) {
        cartChangeEventTrigger.dispatchEvent(cartChangeEvent);
      }
    }

    var getColorOfMainProduct = () => {
      const currentColorSelect = document.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected [data-name="Color"]');
      if (!currentColorSelect) return null;
      return currentColorSelect.value;
    }

    var open = () => {
      if (!pdpUpsellModal) return;
      pdpUpsellModal.classList.add('open');
      const current_color = getColorOfMainProduct();
      pdpUpsellModal.querySelectorAll('[data-variant-color]').forEach(image => {
        image.classList.remove('active');
        if (image.getAttribute('data-variant-color') === current_color) {
          image.classList.add('active');
        }
      });
      pdpUpsellModal.querySelectorAll('[js-item]').forEach(item => {
        item.querySelectorAll('.variant-color-option [data-value]').forEach(colorOption => {
          if (colorOption.getAttribute('data-value') === current_color) {
            colorOption.click();
          }
        });
      });
    }

    var close = () => {
      if (!pdpUpsellModal) return;
      pdpUpsellModal.classList.remove('open');
      goToPreviousStep();
      triggerWaitingEvents();
      pdpUpsellModal.querySelectorAll('[js-item]').forEach((element, index) => {
        if (index > 0) {
          element.remove();
        }
      });
    }

    var goToNextStep = () => {
      if (!pdpUpsellModal) return;
      pdpUpsellModal.classList.add('selecting');
    }

    var goToPreviousStep = () => {
      if (!pdpUpsellModal) return;
      pdpUpsellModal.classList.remove('selecting');
    }

    var generalOptionChanged = (element, container) => {
      if (!element || !element.closest('.variant-option') || !container) return;
      element.closest('.variant-option').querySelectorAll('[data-value]').forEach(valueElement => {
        valueElement.classList.remove('active');
      });
      element.classList.add('active');
      const currentValue = element.closest('.variant-option').querySelector('[js-current-value]');
      if (currentValue) {
        currentValue.innerText = element.getAttribute('data-value');
      }
    }

    var colorChanged = (element, container) => {
      if (!element || !element.closest('.variant-color-option') || !container) return;
      const variantId = element.getAttribute('data-variant-id');
      if (variantId !== '') {
        container.querySelectorAll('.image-wrapper img').forEach(image => {
          if (image.getAttribute('data-variant-id') === variantId) {
            image.classList.add('active');
          } else {
            image.classList.remove('active');
          }
        });
      }
    }

    var addItem = () => {
      if (!pdpUpsellModal || pdpUpsellModal.querySelectorAll('[js-item]').length < 1) return;
      const itemList = pdpUpsellModal.querySelector('[js-item-list]');
      const item = pdpUpsellModal.querySelectorAll('[js-item]')[pdpUpsellModal.querySelectorAll('[js-item]').length - 1];
      itemList.innerHTML += item.outerHTML;
    }

    var getCurrentVariantId = (item) => {
      if (!pdpUpsellModal || !pdpUpsellModal.querySelector('script') || !item) return null;
      const productInfo = JSON.parse(pdpUpsellModal.querySelector('script').innerHTML);
      if (!productInfo.variants) return null;
      const valueList = [];
      item.querySelectorAll('.variant-option').forEach(element => {
        valueList.push(element.querySelector('.active[data-value]').getAttribute('data-value'))
      });
      let variant_id = null;
      productInfo.variants.forEach(variant => {
        if (arraysEqual(variant.options, valueList)) {
          variant_id = variant.id;
        }
      });
      return variant_id;
    }

    var addUpsellProducts = async () => {
      if (!pdpUpsellModal) return;
      let variant_id_list = [];
      pdpUpsellModal.querySelectorAll('[js-item]').forEach(item => {
        const variant_id = getCurrentVariantId(item);
        if (variant_id)
          variant_id_list.push(variant_id);
      });

      const items = variant_id_list.map(id => ({
        id,
        quantity: 1
      }));
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: JSON.stringify({ items }),
          headers: {
            "Content-Type": "application/json",
          }
        });

        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          close();
          document.dispatchEvent(new CustomEvent("cart:refresh"));

        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          close();
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        triggerWaitingEvents();
      }
    }

    var initialize = () => {
      pdpUpsellModal = document.querySelector('[js-pdp-upsell-modal]');

      if (pdpUpsellModal) {
        pdpUpsellModal.querySelectorAll('[js-close]').forEach(element => {
          element.addEventListener('click', () => {
            close();
          });
        });
        pdpUpsellModal.querySelectorAll('[js-go-to-next-step]').forEach(element => {
          element.addEventListener('click', () => {
            goToNextStep();
          });
        });
        pdpUpsellModal.querySelectorAll('[js-plus-item]').forEach(element => {
          element.addEventListener('click', () => {
            addItem();
          });
        });
        pdpUpsellModal.querySelectorAll('[js-atc]').forEach(element => {
          element.addEventListener('click', () => {
            addUpsellProducts();
          });
        })
        document.addEventListener('click', (event) => {
          let element = null;
          if (event.target.closest('[data-value]') && event.target.closest('.variant-option')) {
            element = event.target.closest('[data-value]');
            generalOptionChanged(element, element.closest('[js-item]'));
          }
          if (event.target.closest('[data-value]') && event.target.closest('.variant-color-option')) {
            element = event.target.closest('[data-value]');
            colorChanged(element, element.closest('[js-item]'));
          }
          if (event.target.closest('[js-remove-item]') && event.target.closest('[js-item]')) {
            if (pdpUpsellModal.querySelectorAll('[js-item]').length > 1) {
              event.target.closest('[js-item]').remove();
            } else {
              goToPreviousStep();
            }
          }
        });
      }

      document.addEventListener('product:upsell-product:ready', (e) => {
        variantAddEventTrigger = e.detail.variantAddEventTrigger;
        variantAddEvent = e.detail.variantAddEvent;
        cartChangeEventTrigger = e.detail.cartChangeEventTrigger;
        cartChangeEvent = e.detail.cartChangeEvent;
        if (pdpUpsellModal && document.body.hasAttribute('pdp-upsell-modal-ab-test')) {
          open();
        } else {
          triggerWaitingEvents();
        }
      });
    }
    return {
      init: initialize
    }
  })();

  var OptimizedVariantPickerApp = (() => {
    var initInfiniteOptions = () => {
      const kachingBundleCount = document.querySelectorAll('.kaching-bundles__bar').length;
      const personalizationCount = document.querySelectorAll('#infiniteoptions-container>div').length;
      const count_per_unit = personalizationCount / kachingBundleCount;
      document.querySelectorAll('#infiniteoptions-container>div').forEach((element, index) => {
        const inputElement = element.querySelector('input[type=text]');
        if (inputElement) {
          inputElement.placeholder = 'Type name or text here*';
        }
        const labelElement = element.querySelector('.spb-label-tooltip label');
        if (labelElement) {
          if (String(labelElement.innerHTML).includes('Thong'))
            labelElement.innerHTML = `#${parseInt(index/count_per_unit)+1} Thong`;
          if (String(labelElement.innerHTML).includes('Bra'))
            labelElement.innerHTML = `#${parseInt(index/count_per_unit)+1} Bra`;
        }
        const infoModalElementHtml = document.querySelector('[js-infinite-options-info-modal]');
        if (infoModalElementHtml) {
          const infoElementHtml = `
            <span class="info-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_502_260)">
                  <path d="M7.9987 14.6667C11.6806 14.6667 14.6654 11.6819 14.6654 8.00004C14.6654 4.31814 11.6806 1.33337 7.9987 1.33337C4.3168 1.33337 1.33203 4.31814 1.33203 8.00004C1.33203 11.6819 4.3168 14.6667 7.9987 14.6667Z" stroke="#2D2B29" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 10.6667V8" stroke="#2D2B29" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 5.33337H8.00667" stroke="#2D2B29" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_502_260">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div class="info-modal">
              ${infoModalElementHtml.innerHTML}
            </div>
          `;
          element.innerHTML = element.innerHTML + infoElementHtml;
          const infoIconElement = element.querySelector('.info-icon');
          const infoModalElement = element.querySelector('.info-modal');
          if (infoIconElement && infoModalElement) {
            infoIconElement.addEventListener('click', () => {
              infoModalElement.classList.add('open');
            });
            infoIconElement.addEventListener('mouseover', () => {
              infoModalElement.classList.add('open');
            });
            infoIconElement.addEventListener('focusout', () => {
              infoModalElement.classList.remove('open');
            });
            infoIconElement.addEventListener('mouseout', () => {
              infoModalElement.classList.remove('open');
            });
          }
        }
      });
    }
    var initKachingBundlePicker = () => {
      const kachingBundleCount = document.querySelectorAll('.kaching-bundles__bar').length;
      const personalizationCount = document.querySelectorAll('#infiniteoptions-container>div').length;
      const count_per_unit = personalizationCount / kachingBundleCount;
      document.querySelectorAll('.kaching-bundles__bar-variant-selects select').forEach((element) => {
        const newElement = document.createElement('div');
        newElement.setAttribute('data-name', element.getAttribute('data-name'));
        newElement.classList.add('kaching-bundles__bar-variant-custom-selects');
        let image_url;
        let option_image_url;
        if (element.getAttribute('data-name') === 'Color' && window.productVariantsInfo) {
          let matchingVariant = window.productVariantsInfo.find(variant => variant.option1 === element.value || variant.option2 === element.value || variant.option3 === element.value);
          if (matchingVariant.featured_image)
            image_url = matchingVariant.featured_image.src;
        }
        newElement.innerHTML = `
          <div class="select-trigger">
            <div class="selected-value">${
              (image_url) ?
                `
                  <div class="image-wrapper">
                    <img src="${image_url.replace(/\.jpg|\.png|\.webp/i, (match) => `_60x60${match}`)}" width="30px" height="30px" loading="lazy">
                  </div>
                  <span class="text">${element.value}</span>
                `
              : element.value
            }</div>
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="4" viewBox="0 0 10 4" fill="none">
                <g clip-path="url(#clip0_301_6451)">
                  <path d="M5.00005 4L0.669922 0.250001L9.33018 0.25L5.00005 4Z" fill="black"/>
                </g>
                <defs>
                  <clipPath id="clip0_301_6451">
                    <rect width="10" height="4" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
          </div>
          <div class="select-modal">
            <div class="mask" js-close></div>
            <div class="modal-wrapper">
              <div class="modal-header">
                <span class="bar desktop-hide"></span>
                <span class="heading mobile-hide">Choose your ${element.getAttribute('data-name')}</span>
                <span class="icon mobile-hide" js-close>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8.85819 7.52941L14.7719 1.61567C14.8617 1.52898 14.9333 1.42529 14.9825 1.31064C15.0318 1.19599 15.0577 1.07268 15.0588 0.947899C15.0599 0.823122 15.0361 0.699378 14.9888 0.583888C14.9416 0.468398 14.8718 0.363476 14.7836 0.275241C14.6953 0.187007 14.5904 0.117229 14.4749 0.0699787C14.3594 0.0227281 14.2357 -0.0010488 14.1109 3.54812e-05C13.9861 0.00111976 13.8628 0.0270435 13.7482 0.076294C13.6335 0.125544 13.5298 0.197135 13.4432 0.286889L7.52941 6.20063L1.61567 0.286889C1.43844 0.115709 1.20106 0.0209897 0.954663 0.0231308C0.708268 0.0252719 0.472571 0.124103 0.298337 0.298337C0.124103 0.472571 0.0252719 0.708268 0.0231308 0.954663C0.0209897 1.20106 0.115709 1.43844 0.286889 1.61567L6.20063 7.52941L0.286889 13.4432C0.197135 13.5298 0.125544 13.6335 0.076294 13.7482C0.0270435 13.8628 0.00111976 13.9861 3.54812e-05 14.1109C-0.0010488 14.2357 0.0227281 14.3594 0.0699787 14.4749C0.117229 14.5904 0.187007 14.6953 0.275241 14.7836C0.363476 14.8718 0.468398 14.9416 0.583888 14.9888C0.699378 15.0361 0.823122 15.0599 0.947899 15.0588C1.07268 15.0577 1.19599 15.0318 1.31064 14.9825C1.42529 14.9333 1.52898 14.8617 1.61567 14.7719L7.52941 8.85819L13.4432 14.7719C13.5742 14.9042 13.7417 14.9945 13.9243 15.0313C14.1069 15.0681 14.2962 15.0496 14.4683 14.9784C14.6404 14.9071 14.7873 14.7862 14.8904 14.6311C14.9935 14.4761 15.0481 14.2938 15.0473 14.1075C15.0473 13.9841 15.023 13.8619 14.9757 13.7479C14.9285 13.6339 14.8592 13.5304 14.7719 13.4432L8.85819 7.52941Z" fill="black"/>
                  </svg>
                </span>
              </div>
              <div class="modal-body">
                ${
                  Array.from(element.querySelectorAll('option')).map(option => {
                    if (element.getAttribute('data-name') === 'Color' && window.productVariantsInfo) {
                      let matchingVariant = window.productVariantsInfo.find(variant => variant.option1 === option.value || variant.option2 === option.value || variant.option3 === option.value);
                      if (matchingVariant.featured_image)
                        option_image_url = matchingVariant.featured_image.src;
                    }
                    return `
                    <div class="option-item ${(element.value === option.value)?'active':''}" data-value="${option.value}">
                      <span class="icon"></span>
                      ${
                        (option_image_url) ?
                          `
                            <div class="image-wrapper">
                              <img src="${option_image_url.replace(/\.jpg|\.png|\.webp/i, (match) => `_96x96${match}`)}" width="48px" height="48px" loading="lazy">
                            </div>
                          `
                        : ''
                      }
                      <span class="text">${option.value}</span>
                    </div>`;
                  }).join('')
                }
              </div>
            </div>
          </div>
        `;
        element.after(newElement);
        element.classList.add('d-none');
      });
      document.querySelectorAll('.kaching-bundles__bar-variant-selects .kaching-bundles__bar-variant-select').forEach(element => {
        element.addEventListener('custom:value-change', () => {
          const customSelect = element.closest('.kaching-bundles__bar-variant-selects').querySelector(`.kaching-bundles__bar-variant-custom-selects[data-name="${element.getAttribute('data-name')}"]`);
          if (customSelect) {
            const selectedValue = customSelect.querySelector('.selected-value');
            if (selectedValue) {
              selectedValue.innerHTML = element.value;
              if (element.getAttribute('data-name') === 'Color') {
                let matchingVariant = window.productVariantsInfo.find(variant => variant.option1 === element.value || variant.option2 === element.value || variant.option3 === element.value);
                let image_url = matchingVariant.featured_image.src;
                if (image_url) {
                  selectedValue.innerHTML = `
                    <div class="image-wrapper">
                      <img src="${image_url.replace(/\.jpg|\.png|\.webp/i, (match) => `_60x60${match}`)}" width="30px" height="30px" loading="lazy">
                    </div>
                    <span class="text">${element.value}</span>
                  `;
                }
              }
            }
            customSelect.querySelectorAll('.option-item[data-value]').forEach(option => {
              option.classList.remove('active');
              if (option.getAttribute('data-value') === element.value) {
                option.classList.add('active');
              }
            });
          }
          document.querySelectorAll('#infiniteoptions-container>div').forEach((infiniteOption, index) => {

          });
        });
      });
      document.querySelectorAll('.kaching-bundles__bar-variants .kaching-bundles__bar-variant-selects .kaching-bundles__bar-variant-custom-selects').forEach(element => {
        const trigger = element.querySelector('.select-trigger');
        const modal = element.querySelector('.select-modal');
        if (trigger && modal) {
          trigger.addEventListener('click', () => {
            modal.classList.add('open');
          });
          modal.querySelectorAll('[js-close]').forEach(closeButton => {
            closeButton.addEventListener('click', () => {
              modal.classList.remove('open');
            });
          });
          modal.querySelectorAll('.option-item[data-value]').forEach(option => {
            option.addEventListener('click', () => {
              const parentSelect = element.closest('.kaching-bundles__bar-variant-selects').querySelector(`.kaching-bundles__bar-variant-select[data-name="${element.getAttribute('data-name')}"]`);
              if (parentSelect) {
                parentSelect.value = option.getAttribute('data-value');
                parentSelect.dispatchEvent(new CustomEvent('change', {bubbles: true}));
                modal.classList.remove('open');
              }
              setTimeout(() => {
                element.closest('.kaching-bundles__bar-variants').querySelectorAll('.kaching-bundles__bar-variant-select').forEach(eachParentSelect => {
                  eachParentSelect.dispatchEvent(new CustomEvent('custom:value-change', {bubbles: true}));
                });
              });
            });
          });
        }
      });
    }
    var showPersonalization = () => {
      const variantCount = document.querySelectorAll('.kaching-bundles__bar.kaching-bundles__bar--selected .kaching-bundles__bar-variant').length;
      const kachingBundleCount = document.querySelectorAll('.kaching-bundles__bar').length;
      const personalizationCount = document.querySelectorAll('#infiniteoptions-container>div').length;
      const count_per_unit = personalizationCount / kachingBundleCount;
      document.querySelectorAll('#infiniteoptions-container>div').forEach((element, index) => {
        const inputElement = element.querySelector('input[type=text]');
        if (inputElement) {
          inputElement.placeholder = 'Type name or text here*';
        }
        const labelElement = element.querySelector('.spb-label-tooltip label');
        if (labelElement) {
          if (String(labelElement.innerHTML).includes('Thong'))
            labelElement.innerHTML = `#${parseInt(index/count_per_unit)+1} Thong`;
          if (String(labelElement.innerHTML).includes('Bra'))
            labelElement.innerHTML = `#${parseInt(index/count_per_unit)+1} Bra`;
        }
        const image = element.querySelector('.spb-label-tooltip .image-wrapper img');
        if (image) {
          try {
            const imageElement = document.querySelectorAll('.kaching-bundles__bar.kaching-bundles__bar--selected .kaching-bundles__bar-variant-custom-selects[data-name="Color"]')[parseInt(index / count_per_unit)].querySelector('.image-wrapper img');
            image.src = imageElement.src;
          } catch (error) {}
        } else {
          try {
            const imageElement = document.querySelectorAll('.kaching-bundles__bar.kaching-bundles__bar--selected .kaching-bundles__bar-variant-custom-selects[data-name="Color"]')[parseInt(index / count_per_unit)].querySelector('.image-wrapper');
            element.querySelector('.spb-label-tooltip').innerHTML = imageElement.outerHTML + element.querySelector('.spb-label-tooltip').innerHTML;
          } catch (error) {}
        }
        if (kachingBundleCount > 0) {
          if (index < variantCount * count_per_unit) {
            element.classList.remove('d-none');
          } else {
            element.classList.add('d-none');
          }
        }
      });
    }
    var initialize = () => {
      let interval_duration = 0;
      const interval_id_1 = setInterval(() => {
        interval_duration+=10;
        if (document.querySelector('#infiniteoptions-container>div')) {
          clearInterval(interval_id_1);
          initInfiniteOptions();
          showPersonalization();
          clearInterval(interval_id_1);
        }
        if (interval_duration > 30000) {
          clearInterval(interval_id_1);
          console.log('infiniteoption is not found for 30 seconds');
        }
      }, 10);
      const interval_id_2 = setInterval(() => {
        interval_duration+=10;
        if (document.querySelector('kaching-bundles-block')) {
          initKachingBundlePicker();
          clearInterval(interval_id_2);
        }
        if (interval_duration > 30000) {
          clearInterval(interval_id_2);
          console.log('kaching bundle picker is not found for 30 seconds');
        }
      }, 10);
      document.querySelectorAll('.product').forEach(element => {
        element.addEventListener('click', function(e) {
          if (e.target.closest('.kaching-bundles__bars')) {
            setTimeout(() => {
              showPersonalization();
            });
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var PersonalizationGuideModalApp = (() => {
    var open = (container) => {
      if (!container) return;
      const modal = container.querySelector('[js-modal]');
      if (!modal) return;
      modal.classList.add('open');
    }
    var close = (container) => {
      if (!container) return;
      const modal = container.querySelector('[js-modal]');
      if (!modal) return;
      modal.classList.remove('open');
    }
    var initialize = () => {
      document.querySelectorAll('[js-personalization-guide-modal] a[href="#trigger-modal"]').forEach(element => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          open(element.closest('[js-personalization-guide-modal]'));
        });
      });
      document.querySelectorAll('[js-personalization-guide-modal] [js-modal] [js-close]').forEach(element => {
        element.addEventListener('click', () => {
          close(element.closest('[js-personalization-guide-modal]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var SplitFirstWordApp = (() => {
    var splitFirstWord = (element) => {
      if (String(element.innerHTML).split(' ', 2).length > 1) {
        element.innerHTML = `<span class="first-word">${String(element.innerHTML).split(' ', 2)[0]}</span> ${String(element.innerHTML).replace(String(element.innerHTML).split(' ')[0] + ' ', '')}`;
      } else {
        element.innerHTML = `<span class="first-word">${element.innerHTML}</span>`;
      }
    }
    var initialize = () => {
      document.querySelectorAll('[js-split-first-word]').forEach(element => {
        splitFirstWord(element);
      });
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      TooltipIconApp.init();
      TimerApp.init();
      CombinedProductApp.init();
      ShippingProtectApp.init();
      CartTimerApp.init();
      CartDrawerUpsellProductApp.init();
      InfoForLineApp.init();
      PDPUpsellModalApp.init();
      OptimizedVariantPickerApp.init();
      PersonalizationGuideModalApp.init();
      SplitFirstWordApp.init();
    }
    return {
      init: initialize
    }
  })();

  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });

})();